export enum EmailProviderTypes {
  AWS_SES = 'Amazon',
  OFFICE_365 = 'Outlook'
}

export enum EmailProviderTypesTranslation {
  AWS_SES = 'Amazon Simple Email Service',
  OFFICE_365 = 'Office 365'
}
